<template>
    <!-- BEGIN: Content-->
    <div class="categoryList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Ad
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>

        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
              <v-data-table
                dense
                :headers="fields"
                :items="ads"
                class="elevation-0"
                loading="false"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.#="{ index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:item.image="{ item }">
                  <img :src="item.image" style="width:300px;padding: 1%;border-radius: 5px;"/>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="edit(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteq(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Ad</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <div class="row">
                    <div class="col-lg-8">
                      <img :src="previewImage" style="width:30%;"  />
                    </div>
                </div>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-file-input
                      :rules="imageRules"
                      accept="image/png, image/jpeg, image/bmp, image/webp, image/svg"
                      prepend-icon="mdi-camera"
                      label="Select image"
                      v-on:change="onChange"
                      id="image" 
                      name="image"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="create"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update Ad</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <div class="row">
                    <div class="col-lg-8">
                      <img :src="updatepreviewImage" style="width:30%;"  />
                    </div>
                </div>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-file-input
                      :rules="imageRules"
                      accept="image/png, image/jpeg, image/bmp, image/webp, image/svg"
                      prepend-icon="mdi-camera"
                      label="Select image"
                      v-on:change="onChange"
                      id="image" 
                      name="image"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="update"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

    </div>

</template>

<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import {ability} from '../../services/ability'

export default {
    name:"Ads",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          imageRules: [
            value => !value || value.size < 2000000 || 'Image size should be less than 2 MB!',
          ],
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Ads',
              disabled: false,
              href: '',
            },
          ],
          fields: [
             {
              text: '#',
              align: 'start',
              value: '#',
            },
            { text: 'Image', value: 'image' },
            { text: 'Action', value: 'action' },
           ],
           previewImage: null,
           updatepreviewImage: null,
          item:{
                image:"",
                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      if(!ability.can('inventory-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    mounted(){
      if(!this.ads || this.ads.length == 0) {
        this.getAds()
      }
    },
    computed: {
      ads() {
        return this.$store.state.ads
      },
    },
    methods:{
      onChange(e) {
        if(e) {
          this.item.image = e;
          this.previewImage = URL.createObjectURL(this.item.image);
        }
      },
      async getAds(){
        this.isBusy = true
        await axios.get('/ads').then(response=>{
            this.$store.state.ads = response.data.ads
        }).catch(error=>{
            console.log(error)
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('file',this.item.image)

            await axios.post('/ads', fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Advert added successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.getAds()
                this.previewImage = null
                this.clear()
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

        }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('file',this.item.image)
            fd.append('_method',this.item._method)

            await axios.post(`/ads/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Advert updated successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getAds()
                this.previewImage = null
              this.clear()
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async edit(id) {
        let index = this.ads.filter(item => item.id === id );
        this.updatepreviewImage = index[0].image
        this.item.updateID = index[0].id
        this.updatedialog = true
      },
      deleteq(id){
            if(confirm("Are you sure to delete ad ?")){
                axios.delete(`/ads/${id}`).then(response=>{
                  this.$toast.success('Advert deleted successfully','Success',{position: 'topRight',timeout: 7000,})
                    this.getAds()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>